// src/LoginPage.js
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL?.replace(/\/+$/, "") || "";

const apiPath = (path) => `${API_URL}${path}`;

const DEFAULT_REF_CODE = "7065";

const ILETISIM = {
  phone1: "0553 702 74 74",
  phone2: "0533 643 76 15",
  email: "info@haymestasarim.com",
  address: "Vali Rahmi Bey Mah. 157 Sokak No:3 D:7 Buca / İzmir",
};

const LEGAL_ENTITY = {
  name: "Haymes Tasarım (MesYat Dijital)",
  email: ILETISIM.email,
  address: ILETISIM.address,
};

const LEGAL_VERSION = "2026-07-16-v1";

const LEGAL_DOCUMENTS = {
  tr: {
    terms: {
      title: "Bayi Başvuru ve Üyelik Sözleşmesi",
      updated: "Son güncelleme: 16 Temmuz 2026",
      intro:
        "Bu sözleşme, bayi adayı ile Haymes Tasarım (MesYat Dijital) arasındaki başvuru, değerlendirme, hesap güvenliği ve panel kullanım esaslarını düzenler.",
      sections: [
        {
          title: "1. Başvuru ve taraf bilgileri",
          text: "Başvuru sahibi, formda verdiği kimlik, iletişim ve kurum bilgilerinin doğru, güncel ve kendisine ait olduğunu kabul eder. Yanlış veya üçüncü kişilere ait bilgi kullanılması hâlinde başvuru reddedilebilir veya hesap kapatılabilir.",
        },
        {
          title: "2. Onay ve hesap açılışı",
          text: "Başvurunun gönderilmesi otomatik bayilik veya üyelik hakkı doğurmaz. Başvuru idari incelemeye alınır; uygun görülen başvurular ayrıca onaylanır ve kurum kodu sistem tarafından atanır.",
        },
        {
          title: "3. Şifre ve hesap güvenliği",
          text: "Kullanıcı şifresini gizli tutmak, üçüncü kişilerle paylaşmamak ve yetkisiz erişim şüphesini derhâl bildirmekle yükümlüdür. Hesap üzerinden gerçekleştirilen işlemlerde güvenlik kurallarına uyulmalıdır.",
        },
        {
          title: "4. Kullanım kuralları",
          text: "Panel hukuka, dürüstlük kurallarına ve kullanım amacına uygun kullanılmalıdır. Zararlı yazılım, yetkisiz erişim, veri toplama, sistemi aksatma, yanıltıcı satış veya üçüncü kişi haklarını ihlal eden kullanım yasaktır.",
        },
        {
          title: "5. Fikri mülkiyet ve içerik",
          text: "MesYat adı, yazılımı, tasarımları, dokümanları ve ilgili içerikler üzerindeki haklar sahibine aittir. Yazılı izin olmadan kopyalanamaz, tersine mühendislik yapılamaz, devredilemez veya ticari olarak yeniden dağıtılamaz.",
        },
        {
          title: "6. Ücret, proje ve hizmet kapsamı",
          text: "Başvuru formu tek başına ücretli hizmet satın alımı oluşturmaz. Paket, ücret, komisyon, süre, destek ve özel geliştirme koşulları ayrıca sunulan teklif veya sözleşme ile kesinleşir.",
        },
        {
          title: "7. Askıya alma ve sona erdirme",
          text: "Güvenlik riski, mevzuata aykırılık, yanlış beyan veya sözleşme ihlali hâlinde başvuru reddedilebilir; hesap geçici olarak durdurulabilir veya sona erdirilebilir. Emredici mevzuattan doğan haklar saklıdır.",
        },
        {
          title: "8. Uygulanacak hükümler",
          text: "İlişkiye Türkiye Cumhuriyeti mevzuatı uygulanır. Uyuşmazlıklarda emredici görev ve yetki hükümleri ile tarafların kanuni başvuru hakları saklıdır.",
        },
      ],
    },
    kvkk: {
      title: "KVKK Aydınlatma Metni",
      updated: "Son güncelleme: 16 Temmuz 2026",
      intro:
        "6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında, başvuru sırasında işlenen kişisel verileriniz hakkında sizi bilgilendiriyoruz.",
      sections: [
        {
          title: "1. Veri sorumlusu",
          text: `${LEGAL_ENTITY.name}; iletişim: ${LEGAL_ENTITY.email}, adres: ${LEGAL_ENTITY.address}.`,
        },
        {
          title: "2. İşlenen veri kategorileri",
          text: "Ad soyad, kurum/firma bilgisi, telefon, e-posta, kategori, il/ilçe, referans kodu, başvuru notu, hesap ve parola güvenlik verileri ile işlem/log kayıtları işlenebilir. Parolanızın düz metin olarak saklanmaması ve güvenli şekilde özetlenmesi gerekir.",
        },
        {
          title: "3. İşleme amaçları",
          text: "Başvurunun alınması ve değerlendirilmesi, kimlik ve iletişim doğrulaması, hesabın oluşturulması, bayi ilişkisinin yürütülmesi, bilgi güvenliğinin sağlanması, destek verilmesi, kötüye kullanımın önlenmesi ve yasal yükümlülüklerin yerine getirilmesi.",
        },
        {
          title: "4. Hukuki sebepler ve toplama yöntemi",
          text: "Veriler elektronik başvuru formu ve panel işlemleri üzerinden; sözleşmenin kurulması veya ifası, hukuki yükümlülük, bir hakkın tesisi/kullanılması/korunması ve temel haklarınıza zarar vermemek kaydıyla meşru menfaat hukuki sebeplerine dayanılarak toplanabilir.",
        },
        {
          title: "5. Aktarım",
          text: "Veriler; hizmetin yürütülmesi için gerekli olduğu ölçüde yetkili personel, bilişim/barındırma ve güvenlik hizmeti sağlayıcıları ile kanunen yetkili kamu kurumlarına, KVKK’daki aktarım şartlarına uygun olarak aktarılabilir.",
        },
        {
          title: "6. Saklama ve güvenlik",
          text: "Veriler yalnızca işleme amacı ve ilgili mevzuatın gerektirdiği süre boyunca saklanır; süre sonunda silme, yok etme veya anonim hâle getirme süreçleri uygulanır. Uygun teknik ve idari güvenlik tedbirleri alınır.",
        },
        {
          title: "7. KVKK madde 11 kapsamındaki haklarınız",
          text: "Verinizin işlenip işlenmediğini öğrenme, bilgi isteme, amacına uygun kullanılıp kullanılmadığını öğrenme, aktarılan kişileri bilme, düzeltme, silme/yok etme isteme, sonuçların aktarılan kişilere bildirilmesini isteme, otomatik analiz sonucuna itiraz etme ve kanuna aykırı işleme nedeniyle zararın giderilmesini talep etme haklarına sahipsiniz.",
        },
        {
          title: "8. Başvuru yöntemi",
          text: `KVKK kapsamındaki taleplerinizi kimliğinizi doğrulayacak bilgilerle ${LEGAL_ENTITY.email} adresine veya ${LEGAL_ENTITY.address} adresine iletebilirsiniz. Başvurular mevzuattaki süre ve usule göre yanıtlanır.`,
        },
      ],
    },
  },
  en: {
    terms: {
      title: "Dealer Application and Membership Agreement",
      updated: "Last updated: 16 July 2026",
      intro: "This agreement governs the application, review, account security and panel usage relationship with Haymes Tasarım (MesYat Digital). The Turkish text prevails for legal interpretation.",
      sections: [
        { title: "1. Application", text: "The applicant confirms that identity, contact and organisation information is accurate, current and lawfully provided." },
        { title: "2. Approval", text: "Submitting the form does not automatically create dealership or membership rights. Applications are reviewed and approved separately." },
        { title: "3. Account security", text: "The user must keep the password confidential, prevent unauthorised use and promptly report suspected access." },
        { title: "4. Permitted use", text: "The panel must be used lawfully. Unauthorised access, disruption, harmful software, deceptive activity and infringement of third-party rights are prohibited." },
        { title: "5. Intellectual property", text: "MesYat software, designs, documents and related rights remain with their owner and may not be copied, transferred or redistributed without written permission." },
        { title: "6. Commercial scope", text: "The application alone is not a purchase. Package, price, commission, support and custom development terms are finalised in a separate proposal or agreement." },
        { title: "7. Suspension and termination", text: "Applications or accounts may be rejected, suspended or terminated for security risks, unlawful conduct, false information or contractual breach, subject to mandatory law." },
        { title: "8. Governing rules", text: "Turkish law applies and mandatory jurisdiction rules and statutory remedies remain reserved." },
      ],
    },
    kvkk: {
      title: "Personal Data Information Notice (KVKK)",
      updated: "Last updated: 16 July 2026",
      intro: "This notice explains processing under Turkish Law No. 6698. The Turkish text prevails for legal interpretation.",
      sections: [
        { title: "1. Data controller", text: `${LEGAL_ENTITY.name}; ${LEGAL_ENTITY.email}; ${LEGAL_ENTITY.address}.` },
        { title: "2. Data categories", text: "Identity, organisation, phone, email, category, location, referral code, application notes, account security and transaction/log information may be processed." },
        { title: "3. Purposes", text: "Application review, verification, account creation, dealer relationship management, security, support, fraud prevention and legal compliance." },
        { title: "4. Legal grounds", text: "Data may be processed for contract steps, legal obligations, establishment or protection of rights and legitimate interests that do not override fundamental rights." },
        { title: "5. Transfers", text: "Where necessary and lawful, data may be shared with authorised personnel, IT/hosting/security providers and competent authorities." },
        { title: "6. Retention and security", text: "Data is retained only for the applicable purpose and legal period, then deleted, destroyed or anonymised with appropriate safeguards." },
        { title: "7. Your rights", text: "You may exercise the rights provided under Article 11 of Law No. 6698, including access, correction, deletion, objection and compensation where applicable." },
        { title: "8. Contact", text: `Send verified requests to ${LEGAL_ENTITY.email} or ${LEGAL_ENTITY.address}.` },
      ],
    },
  },
  de: {
    terms: {
      title: "Händlerantrag und Mitgliedschaftsvereinbarung",
      updated: "Letzte Aktualisierung: 16. Juli 2026",
      intro: "Diese Vereinbarung regelt Antrag, Prüfung, Kontosicherheit und Panelnutzung mit Haymes Tasarım (MesYat Digital). Für die rechtliche Auslegung ist der türkische Text maßgeblich.",
      sections: [
        { title: "1. Antrag", text: "Der Antragsteller bestätigt, dass Identitäts-, Kontakt- und Unternehmensdaten richtig, aktuell und rechtmäßig angegeben sind." },
        { title: "2. Genehmigung", text: "Die Übermittlung begründet nicht automatisch Händler- oder Mitgliedschaftsrechte. Anträge werden gesondert geprüft und genehmigt." },
        { title: "3. Kontosicherheit", text: "Das Passwort ist vertraulich zu behandeln; unbefugte Nutzung ist zu verhindern und verdächtiger Zugriff unverzüglich zu melden." },
        { title: "4. Zulässige Nutzung", text: "Das Panel ist rechtmäßig zu nutzen. Unbefugter Zugriff, Störung, Schadsoftware, Täuschung und die Verletzung von Rechten Dritter sind verboten." },
        { title: "5. Geistiges Eigentum", text: "MesYat-Software, Designs und Dokumente dürfen ohne schriftliche Erlaubnis nicht kopiert, übertragen oder weitergegeben werden." },
        { title: "6. Leistungsumfang", text: "Der Antrag allein ist kein Kauf. Paket, Preis, Provision, Support und Sonderentwicklung werden in einem gesonderten Angebot oder Vertrag festgelegt." },
        { title: "7. Sperrung und Beendigung", text: "Bei Sicherheitsrisiken, Rechtsverstößen, falschen Angaben oder Vertragsverletzungen kann der Antrag abgelehnt oder das Konto gesperrt werden." },
        { title: "8. Anwendbare Regeln", text: "Es gilt türkisches Recht; zwingende Zuständigkeitsregeln und gesetzliche Rechtsbehelfe bleiben vorbehalten." },
      ],
    },
    kvkk: {
      title: "Datenschutzinformation nach KVKK",
      updated: "Letzte Aktualisierung: 16. Juli 2026",
      intro: "Diese Information erläutert die Verarbeitung nach dem türkischen Gesetz Nr. 6698. Für die rechtliche Auslegung ist der türkische Text maßgeblich.",
      sections: [
        { title: "1. Verantwortlicher", text: `${LEGAL_ENTITY.name}; ${LEGAL_ENTITY.email}; ${LEGAL_ENTITY.address}.` },
        { title: "2. Datenkategorien", text: "Identitäts-, Unternehmens-, Telefon-, E-Mail-, Kategorie-, Standort-, Empfehlungscode-, Antrags-, Kontosicherheits- und Protokolldaten können verarbeitet werden." },
        { title: "3. Zwecke", text: "Antragsprüfung, Verifizierung, Kontoerstellung, Händlerverwaltung, Sicherheit, Support, Missbrauchsprävention und rechtliche Pflichten." },
        { title: "4. Rechtsgrundlagen", text: "Daten können für Vertragsmaßnahmen, gesetzliche Pflichten, Rechtsansprüche und berechtigte Interessen unter Wahrung der Grundrechte verarbeitet werden." },
        { title: "5. Übermittlung", text: "Soweit erforderlich und zulässig, können Daten an befugtes Personal, IT-/Hosting-/Sicherheitsanbieter und zuständige Behörden übermittelt werden." },
        { title: "6. Speicherung", text: "Daten werden nur zweck- und gesetzesgemäß gespeichert und anschließend gelöscht, vernichtet oder anonymisiert; geeignete Sicherheitsmaßnahmen werden getroffen." },
        { title: "7. Rechte", text: "Sie können die Rechte aus Artikel 11 des Gesetzes Nr. 6698 ausüben, einschließlich Auskunft, Berichtigung, Löschung, Widerspruch und gegebenenfalls Schadensersatz." },
        { title: "8. Kontakt", text: `Senden Sie verifizierte Anträge an ${LEGAL_ENTITY.email} oder ${LEGAL_ENTITY.address}.` },
      ],
    },
  },
};

function isStrongPassword(value) {
  const password = String(value || "");
  return (
    password.length >= 8 &&
    /[a-zçğıöşü]/.test(password) &&
    /[A-ZÇĞİÖŞÜ]/.test(password) &&
    /\d/.test(password)
  );
}

function LegalDocumentModal({ type, lang, onClose, labels }) {
  const documentGroup = LEGAL_DOCUMENTS[lang] || LEGAL_DOCUMENTS.tr;
  const content = documentGroup[type] || documentGroup.terms;

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/70 px-3 py-4 md:px-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="legal-document-title"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="login-card-anim flex max-h-[92vh] w-full max-w-4xl flex-col overflow-hidden rounded-3xl border border-white/80 bg-white shadow-2xl">
        <div className="flex items-start justify-between gap-4 border-b-4 border-orange-500 bg-gradient-to-r from-slate-950 via-blue-950 to-blue-800 px-5 py-5 text-white md:px-7">
          <div className="min-w-0">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-orange-300">
              MesYat Dijital · Yasal Bilgilendirme
            </p>
            <h3
              id="legal-document-title"
              className="mt-1.5 text-xl font-black leading-tight md:text-2xl"
            >
              {content.title}
            </h3>
            <p className="mt-1 text-xs font-semibold text-white/65">
              {content.updated}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            aria-label={labels.legalClose}
            className="grid h-10 w-10 shrink-0 place-items-center rounded-xl border border-white/20 bg-white/10 text-xl font-black text-white transition hover:bg-white/20"
          >
            ×
          </button>
        </div>

        <div className="overflow-y-auto bg-slate-50 px-4 py-5 md:px-7 md:py-6">
          <div className="rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3 text-sm font-semibold leading-6 text-blue-950">
            {content.intro}
          </div>

          <div className="mt-4 space-y-3">
            {content.sections.map((section) => (
              <section
                key={section.title}
                className="rounded-2xl border border-slate-200 bg-white px-4 py-4 shadow-sm md:px-5"
              >
                <h4 className="text-sm font-black text-slate-900 md:text-base">
                  {section.title}
                </h4>
                <p className="mt-1.5 text-sm font-medium leading-6 text-slate-600">
                  {section.text}
                </p>
              </section>
            ))}
          </div>

          <div className="mt-4 rounded-2xl border border-slate-200 bg-white px-4 py-4 text-sm font-semibold leading-6 text-slate-600">
            <div className="font-black text-slate-900">{LEGAL_ENTITY.name}</div>
            <div>{LEGAL_ENTITY.email}</div>
            <div>{LEGAL_ENTITY.address}</div>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-2 border-t border-slate-200 bg-white px-5 py-4 sm:flex-row sm:justify-end md:px-7">
          <button
            type="button"
            onClick={() => window.print()}
            className="rounded-xl border border-slate-300 bg-white px-5 py-2.5 text-sm font-extrabold text-slate-700 transition hover:bg-slate-50"
          >
            🖨 {labels.legalPrint}
          </button>
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl bg-blue-700 px-6 py-2.5 text-sm font-extrabold text-white transition hover:bg-blue-800"
          >
            {labels.legalClose}
          </button>
        </div>
      </div>
    </div>
  );
}

const KATEGORILER = [
  { value: "1", label: "Sağlık" },
  { value: "2", label: "Eğitim" },
  { value: "3", label: "Restoran" },
  { value: "4", label: "Spor" },
  { value: "5", label: "STK" },
  { value: "6", label: "Finans" },
  { value: "7", label: "Teknoloji" },
  { value: "8", label: "Turizm" },
  { value: "9", label: "Danışmanlık" },
  { value: "10", label: "Emlak" },
  { value: "11", label: "Hizmet" },
  { value: "12", label: "Üretim" },
  { value: "13", label: "Otomotiv" },
  { value: "14", label: "Medya" },
  { value: "15", label: "Enerji" },
  { value: "16", label: "Kişisel Gelişim" },
  { value: "17", label: "Diğer" },
];

function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch {
    return null;
  }
}

function getRefInfo() {
  try {
    const hash = window.location.hash || "";

    // Yeni özel link:
    // https://panel.haymestasarim.com/#/REF/7073
    const refPathMatch = hash.match(/^#\/REF\/([^/?#]+)/i);

    if (refPathMatch?.[1]) {
      return {
        refCode: decodeURIComponent(refPathMatch[1]).trim(),
        locked: true,
        fromLink: true,
      };
    }

    const params = new URLSearchParams(window.location.search || "");
    const qIndex = hash.indexOf("?");

    if (qIndex >= 0) {
      const hashParams = new URLSearchParams(hash.substring(qIndex + 1));

      hashParams.forEach((value, key) => {
        if (!params.has(key)) params.set(key, value);
      });
    }

    const ref =
      params.get("ref") ||
      params.get("referans") ||
      params.get("bayi") ||
      "";

    if (ref) {
      return {
        refCode: String(ref || "").trim(),
        locked: true,
        fromLink: true,
      };
    }

    return {
      refCode: DEFAULT_REF_CODE,
      locked: false,
      fromLink: false,
    };
  } catch {
    return {
      refCode: DEFAULT_REF_CODE,
      locked: false,
      fromLink: false,
    };
  }
}

const T = {
  tr: {
    badge: "Kurumsal Dijital Yönetim Sistemi",
    title: "MesYat Dijital Çözümler Paneli",
    subtitle: "QR Menü, Kasa, Stok, Cari, Randevu ve Bayilik Yönetimi",
    heroTitle: "İşletmeler için tek panelden güçlü dijital yönetim.",
    heroText:
      "Bayileriniz, müşterileriniz ve işletme süreçleriniz için profesyonel, güvenli ve ölçeklenebilir MesYat Dijital altyapısı.",
    feature1: "QR Menü Sistemi",
    feature2: "Kasa & Stok Takibi",
    feature3: "Cari Yönetimi",
    feature4: "Bayilik Başvurusu",
    loginTab: "Firma Girişi",
    registerTab: "Kayıt Ol",
    loginTitle: "Firma Paneli Giriş",
    loginText: "Yetkili firma hesabınızla panele giriş yapın.",
    email: "E-posta",
    panelEmail: "Panel E-posta",
    password: "Şifre",
    createPassword: "Hesap Şifresi",
    confirmPassword: "Şifre Tekrar",
    passwordHint:
      "En az 8 karakter; büyük harf, küçük harf ve rakam içermelidir.",
    passwordRequired: "Şifre ve şifre tekrar alanları zorunludur.",
    passwordWeak:
      "Şifreniz en az 8 karakter olmalı; büyük harf, küçük harf ve rakam içermelidir.",
    passwordMismatch: "Şifreler birbiriyle eşleşmiyor.",
    termsRequired:
      "Devam etmek için Bayi Başvuru ve Üyelik Sözleşmesi’ni kabul etmelisiniz.",
    termsPrefix: "Bayi Başvuru ve Üyelik Sözleşmesi’ni",
    termsSuffix: "okudum ve kabul ediyorum.",
    kvkkPrefix: "Kişisel verilerinizin işlenmesine ilişkin",
    kvkkLink: "KVKK Aydınlatma Metni’ni",
    kvkkSuffix: "başvuru öncesinde inceleyebilirsiniz.",
    marketingConsent:
      "Kampanya, ürün ve hizmet duyurularının e-posta/SMS/telefon yoluyla gönderilmesine izin veriyorum.",
    optional: "İsteğe bağlı",
    legalClose: "Kapat",
    legalPrint: "Yazdır",
    loginBtn: "Giriş Yap",
    forgot: "Şifremi Unuttum",
    wrongLogin: "E-posta veya şifre yanlış",
    membershipInfo:
      "Üyelik ve bayi başvuruları admin onayından sonra aktif edilir.",
    registerTitle: "Bayi Başvuru Formu",
    registerText:
      "Başvurunuzu oluşturun. Kurum kodunuz sistem tarafından otomatik atanır.",
    refCode: "Referans Bayi Kodu",
    refPlaceholder: "Örn: 7065",
    refLocked:
      "Bu referans kodu davet linkinden alınmıştır ve değiştirilemez.",
    refDefault:
      "Link olmadan gelen başvurular varsayılan olarak 7065 referansına bağlanır.",
    fullName: "Ad Soyad",
    fullNamePlaceholder: "Adınız ve soyadınız",
    companyName: "Kurum / Firma Adı",
    companyPlaceholder: "Firma adı / işletme adı",
    category: "Kategori",
    selectCategory: "Kategori Seç",
    city: "İl",
    selectCity: "İl Seçiniz",
    district: "İlçe",
    selectDistrict: "İlçe Seçiniz",
    phone: "Telefon",
    phonePlaceholder: "05...",
    note: "Not",
    notePlaceholder: "Kısa açıklama yazabilirsiniz.",
    sendApplication: "Başvuruyu Gönder",
    sending: "Başvuru Gönderiliyor...",
    requiredRef: "Referans bayi kodu zorunludur.",
    requiredFields:
      "Ad soyad, firma adı, telefon ve e-posta zorunludur.",
    success:
      "Başvurunuz başarıyla alındı. Admin onayından sonra sisteme dahil edileceksiniz.",
    registerError:
      "Başvuru şu anda gönderilemedi. Lütfen daha sonra tekrar deneyin veya iletişime geçin.",
    registerNotice:
      "Başvuru oluşturmak otomatik bayi yetkisi vermez. Kurum kodu sistem tarafından sıraya göre atanır. Kayıt admin tarafından kontrol edilir ve uygun görülürse aktif bayi hesabı açılır.",
    forgotTitle: "Kurumsal Şifre Yenileme",
    forgotText:
      "Kayıtlı e-posta adresinizi yazın. Sistem uygun hesabı bulursa yenileme bağlantısı gönderir.",
    forgotSuccess:
      "Eğer e-posta sistemde kayıtlıysa, şifre yenileme bağlantısı gönderildi.",
    send: "Gönder",
    cancel: "İptal",
    contact: "İletişim",
    copyright: "© 2025 Haymes Tasarım • MesYat Dijital",
  },

  en: {
    badge: "Corporate Digital Management System",
    title: "MesYat Digital Solutions Panel",
    subtitle: "QR Menu, Cash, Stock, Current Account, Booking and Dealer Management",
    heroTitle: "Powerful digital management from a single panel.",
    heroText:
      "A professional, secure and scalable MesYat Digital infrastructure for your dealers, customers and business operations.",
    feature1: "QR Menu System",
    feature2: "Cash & Stock Tracking",
    feature3: "Current Account Management",
    feature4: "Dealer Application",
    loginTab: "Company Login",
    registerTab: "Register",
    loginTitle: "Company Panel Login",
    loginText: "Log in with your authorized company account.",
    email: "Email",
    panelEmail: "Panel Email",
    password: "Password",
    createPassword: "Account Password",
    confirmPassword: "Confirm Password",
    passwordHint:
      "At least 8 characters with uppercase, lowercase and a number.",
    passwordRequired: "Password and confirmation are required.",
    passwordWeak:
      "Use at least 8 characters including uppercase, lowercase and a number.",
    passwordMismatch: "Passwords do not match.",
    termsRequired:
      "You must accept the Dealer Application and Membership Agreement to continue.",
    termsPrefix: "I have read and accept the",
    termsSuffix: ".",
    kvkkPrefix: "Before applying, you can review the",
    kvkkLink: "Personal Data Information Notice (KVKK)",
    kvkkSuffix: ".",
    marketingConsent:
      "I agree to receive campaign, product and service communications by email/SMS/phone.",
    optional: "Optional",
    legalClose: "Close",
    legalPrint: "Print",
    loginBtn: "Login",
    forgot: "Forgot Password",
    wrongLogin: "Email or password is incorrect",
    membershipInfo:
      "Membership and dealer applications are activated after admin approval.",
    registerTitle: "Dealer Application Form",
    registerText:
      "Create your application. Your company code will be assigned automatically by the system.",
    refCode: "Reference Dealer Code",
    refPlaceholder: "Example: 7065",
    refLocked:
      "This reference code was received from the invitation link and cannot be changed.",
    refDefault:
      "Applications without a link are connected to the default reference 7065.",
    fullName: "Full Name",
    fullNamePlaceholder: "Your full name",
    companyName: "Company / Business Name",
    companyPlaceholder: "Company / business name",
    category: "Category",
    selectCategory: "Select Category",
    city: "City",
    selectCity: "Select City",
    district: "District",
    selectDistrict: "Select District",
    phone: "Phone",
    phonePlaceholder: "Phone number",
    note: "Note",
    notePlaceholder: "You can write a short note.",
    sendApplication: "Send Application",
    sending: "Sending Application...",
    requiredRef: "Reference dealer code is required.",
    requiredFields:
      "Full name, company name, phone and email are required.",
    success:
      "Your application has been received. You will be added to the system after admin approval.",
    registerError:
      "Application could not be sent right now. Please try again later or contact us.",
    registerNotice:
      "Submitting an application does not automatically grant dealer access. The company code is assigned automatically in order. The record is reviewed by admin and an active dealer account is opened if approved.",
    forgotTitle: "Corporate Password Reset",
    forgotText:
      "Enter your registered email address. If the system finds a matching account, a reset link will be sent.",
    forgotSuccess:
      "If the email is registered in the system, a password reset link has been sent.",
    send: "Send",
    cancel: "Cancel",
    contact: "Contact",
    copyright: "© 2025 Haymes Tasarım • MesYat Digital",
  },

  de: {
    badge: "Digitales Unternehmensverwaltungssystem",
    title: "MesYat Digitale Lösungen Panel",
    subtitle: "QR-Menü, Kasse, Lager, Kontokorrent, Termin und Händlerverwaltung",
    heroTitle: "Starke digitale Verwaltung über ein einziges Panel.",
    heroText:
      "Eine professionelle, sichere und skalierbare MesYat Digital Infrastruktur für Händler, Kunden und Geschäftsprozesse.",
    feature1: "QR-Menü-System",
    feature2: "Kasse & Lagerverwaltung",
    feature3: "Kontokorrent-Verwaltung",
    feature4: "Händlerantrag",
    loginTab: "Firmenlogin",
    registerTab: "Registrieren",
    loginTitle: "Firmenpanel Login",
    loginText: "Melden Sie sich mit Ihrem autorisierten Firmenkonto an.",
    email: "E-Mail",
    panelEmail: "Panel E-Mail",
    password: "Passwort",
    createPassword: "Kontopasswort",
    confirmPassword: "Passwort bestätigen",
    passwordHint:
      "Mindestens 8 Zeichen mit Großbuchstaben, Kleinbuchstaben und einer Zahl.",
    passwordRequired: "Passwort und Bestätigung sind erforderlich.",
    passwordWeak:
      "Verwenden Sie mindestens 8 Zeichen mit Groß-, Kleinbuchstaben und einer Zahl.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
    termsRequired:
      "Sie müssen die Händlerantrags- und Mitgliedschaftsvereinbarung akzeptieren.",
    termsPrefix: "Ich habe die",
    termsSuffix: "gelesen und akzeptiere sie.",
    kvkkPrefix: "Vor dem Antrag können Sie die",
    kvkkLink: "Datenschutzinformation nach KVKK",
    kvkkSuffix: "einsehen.",
    marketingConsent:
      "Ich möchte Kampagnen-, Produkt- und Serviceinformationen per E-Mail/SMS/Telefon erhalten.",
    optional: "Optional",
    legalClose: "Schließen",
    legalPrint: "Drucken",
    loginBtn: "Einloggen",
    forgot: "Passwort vergessen",
    wrongLogin: "E-Mail oder Passwort ist falsch",
    membershipInfo:
      "Mitgliedschaften und Händleranträge werden nach Admin-Freigabe aktiviert.",
    registerTitle: "Händler Bewerbungsformular",
    registerText:
      "Erstellen Sie Ihren Antrag. Ihr Firmencode wird automatisch vom System vergeben.",
    refCode: "Referenz-Händlercode",
    refPlaceholder: "Beispiel: 7065",
    refLocked:
      "Dieser Referenzcode wurde aus dem Einladungslink übernommen und kann nicht geändert werden.",
    refDefault:
      "Anträge ohne Link werden standardmäßig der Referenz 7065 zugeordnet.",
    fullName: "Vor- und Nachname",
    fullNamePlaceholder: "Ihr Vor- und Nachname",
    companyName: "Firma / Betriebsname",
    companyPlaceholder: "Firma / Betriebsname",
    category: "Kategorie",
    selectCategory: "Kategorie wählen",
    city: "Stadt",
    selectCity: "Stadt wählen",
    district: "Bezirk",
    selectDistrict: "Bezirk wählen",
    phone: "Telefon",
    phonePlaceholder: "Telefonnummer",
    note: "Notiz",
    notePlaceholder: "Sie können eine kurze Notiz schreiben.",
    sendApplication: "Antrag senden",
    sending: "Antrag wird gesendet...",
    requiredRef: "Referenz-Händlercode ist erforderlich.",
    requiredFields:
      "Name, Firmenname, Telefon und E-Mail sind erforderlich.",
    success:
      "Ihr Antrag wurde erfolgreich empfangen. Nach Admin-Freigabe werden Sie dem System hinzugefügt.",
    registerError:
      "Der Antrag konnte derzeit nicht gesendet werden. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns.",
    registerNotice:
      "Ein Antrag gewährt nicht automatisch Händlerrechte. Der Firmencode wird automatisch der Reihe nach vergeben. Der Eintrag wird vom Admin geprüft und bei Freigabe wird ein aktives Händlerkonto eröffnet.",
    forgotTitle: "Firmenpasswort zurücksetzen",
    forgotText:
      "Geben Sie Ihre registrierte E-Mail-Adresse ein. Wenn ein passendes Konto gefunden wird, wird ein Link gesendet.",
    forgotSuccess:
      "Wenn die E-Mail im System registriert ist, wurde ein Link zum Zurücksetzen gesendet.",
    send: "Senden",
    cancel: "Abbrechen",
    contact: "Kontakt",
    copyright: "© 2025 Haymes Tasarım • MesYat Digital",
  },
};

const LoginPage = ({ onLoginSuccess }) => {
  const refInfo = useMemo(() => getRefInfo(), []);

  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("lang") || "tr";
    return T[saved] ? saved : "tr";
  });

  const t = T[lang];

  const [activeTab, setActiveTab] = useState(
    refInfo.fromLink ? "register" : "login"
  );

  const [email, setEmail] = useState("");
  const [sifre, setSifre] = useState("");
  const [hata, setHata] = useState("");

  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMsg, setForgotMsg] = useState("");

  const [refCode, setRefCode] = useState(
    refInfo.refCode || DEFAULT_REF_CODE
  );

  const [basvuruLoading, setBasvuruLoading] = useState(false);
  const [basvuruMsg, setBasvuruMsg] = useState("");
  const [basvuruHata, setBasvuruHata] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [marketingConsent, setMarketingConsent] = useState(false);
  const [legalOpen, setLegalOpen] = useState(null);

  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [basvuruForm, setBasvuruForm] = useState({
    ad_soyad: "",
    firma_adi: "",
    telefon: "",
    email: "",
    kategori_id: "",
    il: "",
    ilce: "",
    not: "",
    sifre: "",
    sifre_tekrar: "",
  });

  const refKodLinktenGeldi = refInfo.locked === true;

  const changeLang = (nextLang) => {
    setLang(nextLang);
    localStorage.setItem("lang", nextLang);
  };

  const updateBasvuru = (key, value) => {
    setBasvuruForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    fetch(apiPath("/api/auth/locations/tr/cities"))
      .then((r) => r.json())
      .then((d) => setCities(Array.isArray(d) ? d : []))
      .catch(() => setCities([]));
  }, []);

  useEffect(() => {
    setBasvuruForm((prev) => ({
      ...prev,
      ilce: "",
    }));

    if (!basvuruForm.il) {
      setDistricts([]);
      return;
    }

    fetch(apiPath(`/api/auth/locations/tr/districts?city_id=${basvuruForm.il}`))
      .then((r) => r.json())
      .then((d) => setDistricts(Array.isArray(d) ? d : []))
      .catch(() => setDistricts([]));
  }, [basvuruForm.il]);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotMsg("");

    try {
      await axios.post(apiPath("/api/kurum-passport/forgot-password"), {
        email: forgotEmail,
      });

      setForgotMsg(t.forgotSuccess);
      setForgotEmail("");
    } catch (err) {
      setForgotMsg(t.forgotSuccess);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setHata("");

    try {
      const res = await axios.post(apiPath("/api/giris"), { email, sifre });

      if (res.data?.token) {
        localStorage.setItem("token", res.data.token);
        axios.defaults.headers.common["Authorization"] = `Bearer ${res.data.token}`;
      }

      let me = res.data?.kullanici || res.data?.user || null;

      if (!me && res.data?.token) {
        const p = decodeJwt(res.data.token);

        if (p) {
          me = {
            id: p.id,
            email: p.email,
            username: p.username,
            name: p.name,
            kurum_id: p.kurum_id,
            sube_id: p.sube_id,
            rol: p.rol || p.role,
            role: p.role || p.rol,
            is_staff_user: p.is_staff_user === true,
            permissions: p.permissions || {},
            branchScope: p.branch_scope || p.branchScope || "all",
            allowed_sube_ids: p.allowed_sube_ids || [],
          };
        }
      }

      if (me) {
        localStorage.setItem("me", JSON.stringify(me));
        localStorage.setItem("kullanici", JSON.stringify(me));
        localStorage.setItem("user", JSON.stringify(me));

        localStorage.setItem("rol", me.rol || me.role || "");
        localStorage.setItem("role", me.role || me.rol || "");
        localStorage.setItem("kurum_id", String(me.kurum_id || ""));
      }

      window.dispatchEvent(new CustomEvent("auth:login", { detail: me }));

      setEmail("");
      setSifre("");

      onLoginSuccess && onLoginSuccess();
    } catch (err) {
      setHata(t.wrongLogin);
    }
  };

  const handleBayiBasvuru = async (e) => {
    e.preventDefault();

    setBasvuruMsg("");
    setBasvuruHata("");

    const temizRef =
      String(refCode || DEFAULT_REF_CODE).trim() || DEFAULT_REF_CODE;

    const adSoyad = String(basvuruForm.ad_soyad || "").trim();
    const firmaAdi = String(basvuruForm.firma_adi || "").trim();
    const telefon = String(basvuruForm.telefon || "").trim();
    const basvuruEmail = String(basvuruForm.email || "").trim();
    const kayitSifresi = String(basvuruForm.sifre || "");
    const kayitSifresiTekrar = String(basvuruForm.sifre_tekrar || "");

    if (!temizRef) {
      setBasvuruHata(t.requiredRef);
      return;
    }

    if (!adSoyad || !firmaAdi || !telefon || !basvuruEmail) {
      setBasvuruHata(t.requiredFields);
      return;
    }

    if (!kayitSifresi || !kayitSifresiTekrar) {
      setBasvuruHata(t.passwordRequired);
      return;
    }

    if (!isStrongPassword(kayitSifresi)) {
      setBasvuruHata(t.passwordWeak);
      return;
    }

    if (kayitSifresi !== kayitSifresiTekrar) {
      setBasvuruHata(t.passwordMismatch);
      return;
    }

    if (!termsAccepted) {
      setBasvuruHata(t.termsRequired);
      return;
    }

    setBasvuruLoading(true);

    try {
      await axios.post(apiPath("/api/bayilik/davet-kayit"), {
        ref_code: temizRef,
        referans_code: temizRef,
        bayi_kodu: temizRef,

        ad_soyad: adSoyad,
        firma_adi: firmaAdi,

        telefon,
        email: basvuruEmail,

        // Mevcut backend alan adlarıyla uyumluluk için iki yaygın isim de gönderilir.
        sifre: kayitSifresi,
        password: kayitSifresi,
        sifre_tekrar: kayitSifresiTekrar,
        password_confirmation: kayitSifresiTekrar,

        uyelik_sozlesmesi_kabul: true,
        uyelik_sozlesmesi_kabul_tarihi: new Date().toISOString(),
        uyelik_sozlesmesi_surumu: LEGAL_VERSION,
        kvkk_aydinlatma_sunuldu: true,
        kvkk_aydinlatma_surumu: LEGAL_VERSION,
        ticari_ileti_izni: marketingConsent,
        ticari_ileti_izni_tarihi: marketingConsent
          ? new Date().toISOString()
          : null,

        kategori_id: basvuruForm.kategori_id
          ? Number(basvuruForm.kategori_id)
          : null,

  il: basvuruForm.il ? Number(basvuruForm.il) : null,
ilce: basvuruForm.ilce ? Number(basvuruForm.ilce) : null,

// Backend farklı isim bekliyorsa da kayıt kaybolmasın
il_id: basvuruForm.il ? Number(basvuruForm.il) : null,
ilce_id: basvuruForm.ilce ? Number(basvuruForm.ilce) : null,
city_id: basvuruForm.il ? Number(basvuruForm.il) : null,
district_id: basvuruForm.ilce ? Number(basvuruForm.ilce) : null,
sehir_id: basvuruForm.il ? Number(basvuruForm.il) : null,

not: basvuruForm.not,

        kaynak: refInfo.fromLink
          ? "ref_link_bayi_kayit"
          : "panel_login_bayi_kayit",

        dil: lang,
      });

      setBasvuruMsg(t.success);

      setBasvuruForm({
        ad_soyad: "",
        firma_adi: "",
        telefon: "",
        email: "",
        kategori_id: "",
        il: "",
        ilce: "",
        not: "",
        sifre: "",
        sifre_tekrar: "",
      });

      setTermsAccepted(false);
      setMarketingConsent(false);

      if (!refKodLinktenGeldi) {
        setRefCode(DEFAULT_REF_CODE);
      }
    } catch (err) {
      setBasvuruHata(
        err?.response?.data?.message || t.registerError
      );
    } finally {
      setBasvuruLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-gradient-to-br from-[#06152E] via-[#0B2854] to-[#163A82] relative overflow-hidden">
      <style>
        {`
          @keyframes loginFadeUp {
            from {
              opacity: 0;
              transform: translateY(22px) scale(0.98);
            }
            to {
              opacity: 1;
              transform: translateY(0) scale(1);
            }
          }

          @keyframes softFloat {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-12px);
            }
          }

          @keyframes glowPulse {
            0%, 100% {
              box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.22);
            }
            50% {
              box-shadow: 0 0 0 18px rgba(249, 115, 22, 0);
            }
          }

          @keyframes shineMove {
            0% {
              transform: translateX(-120%);
            }
            100% {
              transform: translateX(120%);
            }
          }

          .login-card-anim {
            animation: loginFadeUp .45s ease-out;
          }

          .soft-float {
            animation: softFloat 5s ease-in-out infinite;
          }

          .glow-pulse {
            animation: glowPulse 2.4s ease-in-out infinite;
          }

          .shine-box {
            position: relative;
            overflow: hidden;
          }

          .shine-box::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 45%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,.18), transparent);
            animation: shineMove 4s ease-in-out infinite;
          }
        `}
      </style>

      <div className="absolute -top-28 -left-28 w-80 h-80 rounded-full bg-blue-400/20 blur-3xl" />
      <div className="absolute top-44 -right-28 w-96 h-96 rounded-full bg-orange-400/20 blur-3xl" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[620px] h-[260px] rounded-full bg-white/10 blur-3xl" />

      <div className="relative z-10 w-full text-center pt-7 md:pt-10 px-4">
        <div className="flex justify-center mb-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/15 text-white/90 text-xs md:text-sm font-bold backdrop-blur">
            <span className="w-2 h-2 rounded-full bg-orange-400 glow-pulse" />
            {t.badge}
          </div>
        </div>

        <h1 className="text-white text-2xl md:text-4xl font-extrabold tracking-wide drop-shadow-lg">
          {t.title}
        </h1>

        <p className="text-white/80 text-sm md:text-base mt-3 max-w-2xl mx-auto">
          {t.subtitle}
        </p>

        <div className="flex justify-center gap-2 mt-5">
          {[
            ["tr", "TR"],
            ["en", "EN"],
            ["de", "DE"],
          ].map(([key, label]) => (
            <button
              key={key}
              type="button"
              onClick={() => changeLang(key)}
              className={`px-4 py-2 rounded-full text-xs font-extrabold border transition ${
                lang === key
                  ? "bg-orange-500 text-white border-orange-400 shadow-lg shadow-orange-500/25"
                  : "bg-white/10 text-white/80 border-white/15 hover:bg-white/20"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="relative z-10 flex justify-center px-4 py-8 md:py-10">
        <div className="w-full max-w-6xl grid grid-cols-1 lg:grid-cols-[1fr_500px] gap-6 lg:gap-8 items-center">
          <div className="hidden lg:block text-white pr-6">
            <div className="soft-float inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-white/12 border border-white/15 shadow-2xl mb-6 backdrop-blur">
              <span className="text-4xl">🚀</span>
            </div>

            <h2 className="text-4xl font-extrabold leading-tight mb-5">
              {t.heroTitle}
            </h2>

            <p className="text-white/78 text-lg leading-8 max-w-xl">
              {t.heroText}
            </p>

            <div className="grid grid-cols-2 gap-3 mt-8 max-w-xl">
              {[t.feature1, t.feature2, t.feature3, t.feature4].map((item) => (
                <div
                  key={item}
                  className="shine-box bg-white/10 border border-white/15 rounded-2xl px-4 py-3 text-sm font-bold backdrop-blur"
                >
                  ✓ {item}
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-3xl bg-white/10 border border-white/15 p-5 backdrop-blur">
              <div className="text-sm font-extrabold text-white mb-3">
                {t.contact}
              </div>

              <div className="space-y-2 text-white/85 text-sm font-semibold">
                <div>📞 {ILETISIM.phone1}</div>
                <div>📞 {ILETISIM.phone2}</div>
                <div>📧 {ILETISIM.email}</div>
                <div>📍 {ILETISIM.address}</div>
              </div>
            </div>
          </div>

          <div className="login-card-anim w-full bg-white/95 backdrop-blur shadow-2xl rounded-[28px] p-5 md:p-8 border border-white/80">
            <div className="lg:hidden text-center mb-5">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-gradient-to-br from-blue-600 to-orange-500 text-white text-2xl shadow-lg mb-3">
                🚀
              </div>
              <p className="text-gray-500 text-sm font-semibold">
                {t.heroText}
              </p>
            </div>

            <div className="grid grid-cols-2 gap-2 bg-gray-100 rounded-2xl p-1 mb-7">
              <button
                type="button"
                onClick={() => {
                  setActiveTab("login");
                  setHata("");
                }}
                className={`py-3 rounded-xl text-sm font-extrabold transition ${
                  activeTab === "login"
                    ? "bg-blue-600 text-white shadow-lg shadow-blue-600/25"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {t.loginTab}
              </button>

              <button
                type="button"
                onClick={() => {
                  setActiveTab("register");
                  setBasvuruHata("");
                  setBasvuruMsg("");
                }}
                className={`py-3 rounded-xl text-sm font-extrabold transition ${
                  activeTab === "register"
                    ? "bg-orange-500 text-white shadow-lg shadow-orange-500/25"
                    : "text-gray-600 hover:text-gray-900"
                }`}
              >
                {t.registerTab}
              </button>
            </div>

            {activeTab === "login" ? (
              <>
                <div className="text-center mb-6">
                  <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900">
                    {t.loginTitle}
                  </h2>
                  <p className="text-gray-500 text-sm mt-2">
                    {t.loginText}
                  </p>
                </div>

                {hata && (
                  <div className="bg-red-50 border border-red-200 text-red-700 text-sm text-center mb-4 rounded-xl px-4 py-3 font-bold">
                    {hata}
                  </div>
                )}

                <form onSubmit={handleLogin} className="space-y-5">
                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.email}
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 bg-white text-gray-900"
                      placeholder="ornek@firma.com"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.password}
                    </label>
                    <input
                      type="password"
                      value={sifre}
                      onChange={(e) => setSifre(e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-blue-600 bg-white text-gray-900"
                      placeholder="••••••••"
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-extrabold transition shadow-lg shadow-blue-600/25"
                  >
                    {t.loginBtn}
                  </button>
                </form>

                <div className="flex items-center justify-end mt-4">
                  <button
                    type="button"
                    onClick={() => setForgotOpen(true)}
                    className="text-sm text-blue-600 hover:underline font-bold"
                  >
                    {t.forgot}
                  </button>
                </div>

                <div className="mt-6 rounded-2xl bg-blue-50 border border-blue-100 px-4 py-4 text-center">
                  <p className="text-gray-700 text-sm font-bold">
                    {t.membershipInfo}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="text-center mb-6">
                  <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900">
                    {t.registerTitle}
                  </h2>
                  <p className="text-gray-500 text-sm mt-2">
                    {t.registerText}
                  </p>
                </div>

                {basvuruMsg && (
                  <div className="bg-green-50 border border-green-200 text-green-700 text-sm mb-4 rounded-xl px-4 py-3 font-bold">
                    {basvuruMsg}
                  </div>
                )}

                {basvuruHata && (
                  <div className="bg-red-50 border border-red-200 text-red-700 text-sm mb-4 rounded-xl px-4 py-3 font-bold">
                    {basvuruHata}
                  </div>
                )}

                <form onSubmit={handleBayiBasvuru} className="space-y-4">
                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.refCode}
                    </label>
                    <input
                      type="text"
                      value={refCode}
                      onChange={(e) => setRefCode(e.target.value)}
                      readOnly={refKodLinktenGeldi}
                      className={`w-full px-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 ${
                        refKodLinktenGeldi
                          ? "bg-gray-100 border-gray-200 text-gray-600 cursor-not-allowed"
                          : "bg-white border-gray-300 text-gray-900"
                      }`}
                      placeholder={t.refPlaceholder}
                      required
                    />

                    <p className="text-xs text-gray-500 mt-1.5 font-semibold">
                      {refKodLinktenGeldi ? t.refLocked : t.refDefault}
                    </p>
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.fullName}
                    </label>
                    <input
                      type="text"
                      value={basvuruForm.ad_soyad}
                      onChange={(e) => updateBasvuru("ad_soyad", e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                      placeholder={t.fullNamePlaceholder}
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.companyName}
                    </label>
                    <input
                      type="text"
                      value={basvuruForm.firma_adi}
                      onChange={(e) => updateBasvuru("firma_adi", e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                      placeholder={t.companyPlaceholder}
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                        {t.phone}
                      </label>
                      <input
                        type="tel"
                        value={basvuruForm.telefon}
                        onChange={(e) => updateBasvuru("telefon", e.target.value)}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                        placeholder={t.phonePlaceholder}
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                        {t.panelEmail}
                      </label>
                      <input
                        type="email"
                        value={basvuruForm.email}
                        onChange={(e) => updateBasvuru("email", e.target.value)}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                        placeholder="ornek@mail.com"
                      required
                    />
                  </div>
                </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                        {t.createPassword}
                      </label>
                      <input
                        type="password"
                        value={basvuruForm.sifre}
                        onChange={(e) => updateBasvuru("sifre", e.target.value)}
                        autoComplete="new-password"
                        minLength={8}
                        maxLength={128}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                        placeholder="••••••••"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                        {t.confirmPassword}
                      </label>
                      <input
                        type="password"
                        value={basvuruForm.sifre_tekrar}
                        onChange={(e) => updateBasvuru("sifre_tekrar", e.target.value)}
                        autoComplete="new-password"
                        minLength={8}
                        maxLength={128}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                        placeholder="••••••••"
                        required
                      />
                    </div>
                  </div>

                  <p className="-mt-2 text-xs text-gray-500 font-semibold leading-5">
                    🔐 {t.passwordHint}
                  </p>

                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.category}
                    </label>
                    <select
                      value={basvuruForm.kategori_id}
                      onChange={(e) => updateBasvuru("kategori_id", e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                    >
                      <option value="">{t.selectCategory}</option>
                      {KATEGORILER.map((k) => (
                        <option key={k.value} value={k.value}>
                          {k.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                        {t.city}
                      </label>
                      <select
                        value={basvuruForm.il}
                        onChange={(e) => updateBasvuru("il", e.target.value)}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900"
                      >
                        <option value="">{t.selectCity}</option>
                        {cities.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                        {t.district}
                      </label>
                      <select
                        value={basvuruForm.ilce}
                        disabled={!districts.length}
                        onChange={(e) => updateBasvuru("ilce", e.target.value)}
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 bg-white text-gray-900 disabled:bg-gray-100 disabled:text-gray-500"
                      >
                        <option value="">{t.selectDistrict}</option>
                        {districts.map((d) => (
                          <option key={d.id} value={d.id}>
                            {d.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-extrabold text-gray-700 mb-1.5">
                      {t.note}
                    </label>
                    <textarea
                      value={basvuruForm.not}
                      onChange={(e) => updateBasvuru("not", e.target.value)}
                      className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 min-h-[90px] resize-none bg-white text-gray-900"
                      placeholder={t.notePlaceholder}
                    />
                  </div>

                  <div className="rounded-2xl border border-blue-200 bg-blue-50/70 p-4 space-y-3">
                    <div className="flex items-start gap-3">
                      <input
                        id="bayi-uyelik-sozlesmesi-kabul"
                        type="checkbox"
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                        className="mt-1 h-5 w-5 shrink-0 rounded border-gray-300 text-blue-600 focus:ring-blue-600"
                        required
                      />
                      <div className="text-sm text-gray-700 font-semibold leading-6">
                        <button
                          type="button"
                          onClick={() => setLegalOpen("terms")}
                          className="font-extrabold text-blue-700 underline underline-offset-2 hover:text-blue-900"
                        >
                          {t.termsPrefix}
                        </button>{" "}
                        <label
                          htmlFor="bayi-uyelik-sozlesmesi-kabul"
                          className="cursor-pointer"
                        >
                          {t.termsSuffix}
                        </label>
                      </div>
                    </div>

                    <div className="h-px bg-blue-200" />

                    <p className="text-sm text-gray-700 font-semibold leading-6">
                      {t.kvkkPrefix}{" "}
                      <button
                        type="button"
                        onClick={() => setLegalOpen("kvkk")}
                        className="font-extrabold text-blue-700 underline underline-offset-2 hover:text-blue-900"
                      >
                        {t.kvkkLink}
                      </button>{" "}
                      {t.kvkkSuffix}
                    </p>
                  </div>

                  <label className="flex items-start gap-3 rounded-2xl border border-gray-200 bg-gray-50 p-4 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={marketingConsent}
                      onChange={(e) => setMarketingConsent(e.target.checked)}
                      className="mt-1 h-5 w-5 shrink-0 rounded border-gray-300 text-orange-500 focus:ring-orange-500"
                    />
                    <span className="text-sm text-gray-600 font-semibold leading-6">
                      {t.marketingConsent}{" "}
                      <span className="inline-flex rounded-full bg-gray-200 px-2 py-0.5 text-[11px] font-extrabold text-gray-600">
                        {t.optional}
                      </span>
                    </span>
                  </label>

                  <button
                    type="submit"
                    disabled={basvuruLoading || !termsAccepted}
                    className="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-orange-300 text-white py-3 rounded-xl font-extrabold transition shadow-lg shadow-orange-500/25"
                  >
                    {basvuruLoading ? t.sending : t.sendApplication}
                  </button>
                </form>

                <div className="mt-5 rounded-2xl bg-gray-50 border border-gray-200 px-4 py-4">
                  <p className="text-gray-600 text-sm leading-6 font-semibold">
                    {t.registerNotice}
                  </p>
                </div>
              </>
            )}

            <div className="lg:hidden mt-6 rounded-2xl bg-gray-50 border border-gray-200 p-4">
              <div className="text-sm font-extrabold text-gray-800 mb-2">
                {t.contact}
              </div>

              <div className="space-y-1 text-gray-600 text-sm font-semibold">
                <div>📞 {ILETISIM.phone1}</div>
                <div>📞 {ILETISIM.phone2}</div>
                <div>📧 {ILETISIM.email}</div>
                <div>📍 {ILETISIM.address}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative z-10 text-center text-white/90 text-sm py-7 px-4">
        <div className="hidden md:flex flex-wrap items-center justify-center gap-3 md:gap-5 font-bold">
          <div>📞 {ILETISIM.phone1}</div>
          <div>📞 {ILETISIM.phone2}</div>
          <div>📧 {ILETISIM.email}</div>
          <div>📍 {ILETISIM.address}</div>
        </div>

        <p className="text-white/60 mt-3">
          {t.copyright}
        </p>
      </div>

      {legalOpen && (
        <LegalDocumentModal
          type={legalOpen}
          lang={lang}
          labels={t}
          onClose={() => setLegalOpen(null)}
        />
      )}

      {forgotOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-4">
          <div className="bg-white w-full max-w-md rounded-2xl p-6 shadow-2xl border border-gray-100 login-card-anim">
            <h3 className="text-xl font-extrabold text-gray-900 mb-2">
              {t.forgotTitle}
            </h3>

            <p className="text-gray-500 text-sm mb-4 font-semibold">
              {t.forgotText}
            </p>

            {forgotMsg && (
              <div className="bg-green-50 border border-green-200 text-green-700 text-sm mb-3 rounded-xl px-4 py-3 font-bold">
                {forgotMsg}
              </div>
            )}

            <form onSubmit={handleForgotPassword} className="space-y-4">
              <input
                type="email"
                value={forgotEmail}
                onChange={(e) => setForgotEmail(e.target.value)}
                placeholder={t.email}
                className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-600 bg-white text-gray-900"
                required
              />

              <div className="flex gap-3">
                <button
                  type="submit"
                  className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-extrabold"
                >
                  {t.send}
                </button>

                <button
                  type="button"
                  onClick={() => setForgotOpen(false)}
                  className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 py-3 rounded-xl font-bold"
                >
                  {t.cancel}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;
